<template>
    <div class="redeem-overlay" v-if="visible">
        <div class="redeem-card">
            <h3>{{ translate('canjearBeneficio') }}</h3>
            <p class="merchant-name" v-if="tarjeta && tarjeta.promocion">{{ tarjeta.promocion.anunciante.name }}</p>

            <div class="redeem-actions" v-if="!scannerActive">
                <button class="btn btn-primary btn-full" @click="onStartScan" :disabled="scanning">
                    {{ translate('escanearQr') }}
                </button>
                <button class="btn btn-secondary btn-full" @click="showCodeInput = !showCodeInput">
                    {{ translate('ingresarCodigo') }}
                </button>
            </div>

            <div v-if="scannerActive" class="scanner-container">
                <div id="benefit-qr-reader"></div>
                <button class="btn btn-secondary btn-full" @click="onStopScan">{{ translate('cancelar') }}</button>
            </div>

            <div v-if="showCodeInput && !scannerActive" class="code-form">
                <input
                    type="text"
                    class="form-control"
                    v-model="codigo"
                    :placeholder="translate('codigoComercioPlaceholder')"
                >
                <button class="btn btn-primary btn-full" @click="onRedeemWithCode" :disabled="!codigo">
                    {{ translate('canjear') }}
                </button>
            </div>

            <button class="btn btn-link btn-close" v-if="!scannerActive" @click="onClose">{{ translate('cancelar') }}</button>
        </div>
    </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode';
import dialogs from '@/services/dialogs';

export default {
    name: 'RedeemBenefit',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        tarjeta: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            showCodeInput: false,
            codigo: '',
            scanning: false,
            scannerActive: false,
            html5QrCode: null
        };
    },
    watch: {
        visible (val) {
            if (!val) {
                this.resetState();
            }
        }
    },
    beforeDestroy () {
        this.stopScanner();
    },
    methods: {
        resetState () {
            this.showCodeInput = false;
            this.codigo = '';
            this.scanning = false;
            this.stopScanner();
        },
        onClose () {
            this.$emit('close');
        },
        parseQrToken (rawValue) {
            if (!rawValue) {
                return null;
            }
            try {
                let parsed = JSON.parse(rawValue);
                if (parsed && parsed.token) {
                    return parsed.token;
                }
            } catch (e) {
                // not JSON
            }
            if (rawValue.indexOf('token=') >= 0) {
                let match = rawValue.match(/token=([^&]+)/);
                return match ? match[1] : null;
            }
            return rawValue;
        },
        async onStartScan () {
            this.scanning = true;
            this.scannerActive = true;
            this.showCodeInput = false;
            await this.$nextTick();
            try {
                this.html5QrCode = new Html5Qrcode('benefit-qr-reader');
                await this.html5QrCode.start(
                    { facingMode: 'environment' },
                    { fps: 10, qrbox: 250 },
                    (decodedText) => {
                        let token = this.parseQrToken(decodedText);
                        if (token) {
                            this.stopScanner();
                            this.$emit('redeem', { qr_token: token });
                        } else {
                            dialogs.message(this.translate('qrInvalido'), { duration: 8, estado: 'error' });
                        }
                    },
                    () => {}
                );
            } catch (err) {
                console.log('QR scan error', err);
                this.scannerActive = false;
                dialogs.message(this.translate('qrScanError'), { duration: 8, estado: 'error' });
            } finally {
                this.scanning = false;
            }
        },
        async stopScanner () {
            if (this.html5QrCode) {
                try {
                    if (this.html5QrCode.isScanning) {
                        await this.html5QrCode.stop();
                    }
                    await this.html5QrCode.clear();
                } catch (e) {
                    // ignore stop errors
                }
                this.html5QrCode = null;
            }
            this.scannerActive = false;
        },
        async onStopScan () {
            await this.stopScanner();
        },
        onRedeemWithCode () {
            if (!this.codigo) {
                return;
            }
            this.$emit('redeem', { codigo: this.codigo.trim() });
        }
    }
};
</script>

<style scoped>
    .redeem-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1em;
    }
    .redeem-card {
        background: white;
        width: 100%;
        max-width: 420px;
        padding: 1.4em;
        border-radius: 8px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
    }
    .merchant-name {
        text-align: center;
        font-weight: bold;
        margin-bottom: 1em;
    }
    .redeem-actions .btn {
        margin-bottom: 0.8em;
    }
    .scanner-container {
        margin-top: 0.5em;
    }
    #benefit-qr-reader {
        width: 100%;
        min-height: 260px;
        margin-bottom: 0.8em;
    }
    .code-form {
        margin-top: 1em;
    }
    .code-form .btn {
        margin-top: 0.8em;
    }
    .btn-close {
        width: 100%;
        margin-top: 0.5em;
    }
</style>



// WEBPACK FOOTER //
// src/components/elements/RedeemBenefit.vue